// extracted by mini-css-extract-plugin
module.exports = {"seamless-background-image-tape":"styles_seamless-background-image-tape__3rQcF","contents":"styles_contents__cRrQI","shopini-logistics":"styles_shopini-logistics__1ch8M"};